module.exports = __webpack_public_path__ + "img/logo4.90a15a3f.png";